export const QUIZ_ATTEMPT_STATE_FIELDS = `
  fragment QuizAttemptStateFields on QuizAttemptState {
    quizAttemptId
    status
    topicApiName
    topic {
      preamble
      scoreThreshold
      scoreThresholdRequired
      minutesToComplete
    }
    questions {
      questionOrder
      quizQuestionId
      questionText
      response {
        userResponse
        agentGrade
        agentFeedback
        pointScore
        maxPoints
      }
    }
    results {
      overallScore
      scoreThresholdMet
      finishedAt
      retakeAllowed
    }
  }
`;
